
export enum BranchDesignator {
	InHome = "InHome",
	VideoVisit = "VideoVisit",
}
